"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateBuySomeGetSomeAdjustmentByOrderItemMap = exports.getBuySomeGetSomeDiscountDetails = void 0;
const domain_1 = require("@oolio-group/domain");
const computePrice_1 = require("../computePrice");
const common_1 = require("./common");
const getBuySomeGetSomeDiscountDetails = ({ discount, groupByCategories, groupByProducts, }) => {
    var _a, _b;
    const defaultReturnValue = {
        isBuySomeGetSomeRuleMatched: false,
        discountedQtyToApply: 0,
    };
    if (discount.discountRuleType !==
        domain_1.DiscountRuleType.PRODUCT_CATEGORY_BUY_SOME_GET_SOME_RULE) {
        return defaultReturnValue;
    }
    const { qty: purchasedQty = 0, operator: purchasedOperator } = ((_a = discount.advanceRules) === null || _a === void 0 ? void 0 : _a.purchasedCriteria) || {};
    const { qty: discountedQty = 0 } = ((_b = discount.advanceRules) === null || _b === void 0 ? void 0 : _b.discountedCriteria) || {};
    const { purchasedItemsQtyCount, discountedItemsQtyCount } = (0, common_1.getProductCategoriesCount)(discount, groupByCategories, groupByProducts);
    if (purchasedItemsQtyCount < purchasedQty)
        return defaultReturnValue;
    const purchasedItemsQtyRatio = Math.floor(purchasedItemsQtyCount / purchasedQty);
    let discountedQtyToApply = purchasedItemsQtyRatio
        ? Math.floor(discountedItemsQtyCount / discountedQty)
        : 0;
    if (purchasedOperator === domain_1.DiscountOperator.EXACTLY) {
        discountedQtyToApply =
            discountedQtyToApply > purchasedItemsQtyRatio
                ? purchasedItemsQtyRatio * discountedQty
                : discountedQtyToApply * discountedQty;
    }
    else if (discountedItemsQtyCount) {
        /*
          If purchased operator is MORE_THEN then we're applying discount for only defined discounted rule
          Example: Buy more then 3 coffee and get 1 free
            - In above example when there are more then 3 coffee added to cart then we would apply discount to only 1 coffee
              no matter if 5 coffees are there or 10 coffees
        **/
        discountedQtyToApply =
            discountedItemsQtyCount >= discountedQty ? discountedQty : 0;
    }
    if (purchasedItemsQtyCount >= purchasedQty && discountedQtyToApply) {
        defaultReturnValue.isBuySomeGetSomeRuleMatched = true;
        defaultReturnValue.discountedQtyToApply = discountedQtyToApply;
    }
    return defaultReturnValue;
};
exports.getBuySomeGetSomeDiscountDetails = getBuySomeGetSomeDiscountDetails;
/**
 * This will apply discount to all the discounted items as rules matched
 * Ex: Buy 1 Pizza and get 1 Drink free
 * You've added 1 pizza and now you're adding 1 drink so discount would apply on drink
 */
const setBuySomeGetSomeDiscountOnItems = (orderItem, discount, adjustmentByOrderItemMap, remainQtyToApply) => {
    orderItem.forEach(item => {
        var _a;
        if (remainQtyToApply <= 0)
            return;
        const appliedDiscount = (_a = item.adjustments) === null || _a === void 0 ? void 0 : _a[0];
        if ((0, common_1.isAdvancedDiscountApplicable)(appliedDiscount, discount, item.id, adjustmentByOrderItemMap)) {
            if (item.quantity > remainQtyToApply
            // &&operator !== DiscountOperator.MORE_THAN
            ) {
                adjustmentByOrderItemMap[item.id] = {
                    splitQty: remainQtyToApply,
                };
            }
            else {
                adjustmentByOrderItemMap[item.id] = {
                    adjustment: {
                        ...discount,
                        quantity: (0, common_1.getDiscountQuantity)(discount, item.quantity),
                    },
                };
            }
            remainQtyToApply -= item.quantity;
        }
    });
};
/**
 *
 * @param orderItems cart items
 * @param discount discount that we need to remove from cart items
 * @param maxDiscountQtyToApply it indicate the no of qty for which we need to apply discount
 * @param qtyToRemove no. of quantities that we need to remove
 * @param adjustmentByOrderItemMap object to contain adjustment info item vise
 */
const removeAppliedDiscount = (orderItems, discount, maxDiscountQtyToApply, qtyToRemove, adjustmentByOrderItemMap) => {
    qtyToRemove = Math.abs(qtyToRemove);
    if (!maxDiscountQtyToApply) {
        orderItems.forEach(item => {
            var _a;
            const appliedDiscount = (_a = item.adjustments) === null || _a === void 0 ? void 0 : _a[0];
            if (appliedDiscount &&
                appliedDiscount.id === discount.id &&
                !adjustmentByOrderItemMap[item.id]) {
                adjustmentByOrderItemMap[item.id] = { adjustment: undefined };
            }
        });
        return;
    }
    if (qtyToRemove) {
        orderItems.forEach(item => {
            var _a, _b;
            const appliedDiscountId = (_b = (_a = item.adjustments) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.id;
            if (qtyToRemove <= 0)
                return;
            const appliedItemQuantity = adjustmentByOrderItemMap[item.id]
                ? item.quantity
                : 0;
            qtyToRemove -= appliedItemQuantity;
            if (qtyToRemove > 0) {
                if (item.quantity > qtyToRemove) {
                    adjustmentByOrderItemMap[item.id] = { splitQty: qtyToRemove };
                    qtyToRemove -= item.quantity;
                }
                else if (appliedDiscountId === discount.id) {
                    adjustmentByOrderItemMap[item.id] = { adjustment: undefined };
                    qtyToRemove -= item.quantity;
                }
            }
        });
    }
};
/**
 *
 * @param discount to apply on items
 * @param groupByEntities it contain list of all discounted items
 * @param maxDiscountQtyToApply it indicate the no of qty for which we need to apply discount
 * @param adjustmentByOrderItemMap object to contain adjustment info item vise
 * @returns
 */
const generateBuySomeGetSomeAdjustmentByOrderItemMap = (discount, items, maxDiscountQtyToApply = 0, adjustmentByOrderItemMap) => {
    var _a, _b;
    if (!(items === null || items === void 0 ? void 0 : items.length))
        return;
    /**
     * Discounted items with sorted values(Start from lowest unitPrice)
     * Discount would price to the lowest price items first
     */
    const discountedItems = items.sort((item1, item2) => {
        const item1UnitPrice = (0, computePrice_1.computeLineTotal)(item1);
        const item2UnitPrice = (0, computePrice_1.computeLineTotal)(item2);
        if (item1UnitPrice === item2UnitPrice) {
            return item1.quantity - item2.quantity;
        }
        else
            return item1UnitPrice - item2UnitPrice;
    });
    const lowestItemDiscount = (_b = (_a = discountedItems[0]) === null || _a === void 0 ? void 0 : _a.adjustments) === null || _b === void 0 ? void 0 : _b[0];
    const highestDiscountItems = discountedItems.filter(i => {
        var _a;
        return discountedItems[0].id !== i.id &&
            (0, computePrice_1.computeLineTotal)(discountedItems[0]) !== (0, computePrice_1.computeLineTotal)(i) &&
            ((_a = i.adjustments) === null || _a === void 0 ? void 0 : _a.find(a => a.id === discount.id));
    });
    /**
     * If we have lowest item which doesn't applied any discount then remove other items discount
     * After removing discount re-apply discount based on lowest item first (lowest to highest)
     */
    if ((lowestItemDiscount && lowestItemDiscount.id !== discount.id) ||
        (!lowestItemDiscount && highestDiscountItems.length)) {
        highestDiscountItems.forEach(item => {
            adjustmentByOrderItemMap[item.id] = { adjustment: undefined };
        });
        return;
    }
    const appliedDiscountedQty = discountedItems.reduce((initItemVal, item) => {
        var _a;
        const appliedDiscount = (_a = item.adjustments) === null || _a === void 0 ? void 0 : _a[0];
        return appliedDiscount &&
            ((appliedDiscount === null || appliedDiscount === void 0 ? void 0 : appliedDiscount.id) === discount.id || !(appliedDiscount === null || appliedDiscount === void 0 ? void 0 : appliedDiscount.autoApply))
            ? item.quantity + initItemVal
            : initItemVal;
    }, 0);
    const remainQtyToApply = maxDiscountQtyToApply - appliedDiscountedQty;
    // Remove discount from discounted items if purchased items are removed from cart
    if (!maxDiscountQtyToApply || remainQtyToApply < 0) {
        removeAppliedDiscount(discountedItems, discount, maxDiscountQtyToApply, remainQtyToApply, adjustmentByOrderItemMap);
        return;
    }
    // Apply discount on items
    remainQtyToApply &&
        setBuySomeGetSomeDiscountOnItems(discountedItems, discount, adjustmentByOrderItemMap, remainQtyToApply);
};
exports.generateBuySomeGetSomeAdjustmentByOrderItemMap = generateBuySomeGetSomeAdjustmentByOrderItemMap;
//# sourceMappingURL=freeDiscountedHelper.js.map